import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Container,
  IconButton,
  InputBase,
  makeStyles,
  Menu,
  MenuItem,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { patchAgentAction, useDeleteAgentAction, useGetAgentActions, usePatchAgentAction } from '../../hooks/queries/kaiAgent'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import SearchIcon from '@material-ui/icons/Search'
import { TextEditor } from './TextEditor'
import SettingsIcon from '@material-ui/icons/Settings'
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { KAI_AGENT_URL } from '../../config'

const KaiPage = () => {
  // useEffect(() => {
  //   if (KAI_AGENT_URL) {
  //     window.open(KAI_AGENT_URL, '_blank', 'noopener,noreferrer');
  //   }
  // }, []);

  return (
    <section className='bg-light py-5'>
      <Container>
        <Box display='flex' justifyContent='center'>
          <Button variant='outlined' endIcon={<OpenInNewIcon />} onClick={() => window.open(KAI_AGENT_URL, '_blank', 'noopener,noreferrer')}>Kai Agent Dashboard</Button>
        </Box>
      </Container>
    </section>
  )
}

const useStyles = makeStyles((theme) => ({
  search: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    width: '100%',
  },
  searchIcon: {
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingLeft: theme.spacing(1),
  },
}))

function ActionTable() {
  const classes = useStyles()
  const [searchText, setSearchText] = useState('')
  const [actions, setActions] = useState([])
  const [statusType, setStatusType] = useState<'ALL' | 'PENDING_CONSENT' | 'PENDING_RESPONSE' | 'CLOSED'>('ALL')

  const { refetch, isFetching } = useGetAgentActions('kai-actions', setActions)

  const [showMoreView, setShowMoreView] = useState<number | null>(null)
  function toggleShowMoreView(index: any) {
    if (showMoreView == index) {
      setShowMoreView(null)
    } else {
      setShowMoreView(index)
    }
  }

  // async function updateActionAndRefreshData(body: object) {
  //   const res = await mutateAction(body)
  //   await refetch()
  //   return res
  // }

  function filterActionsOnSearch(actions) {
    return actions.filter((a: any) => JSON.stringify(a).toLowerCase().includes(searchText.toLowerCase()))
  }

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div
          style={{
            paddingTop: 10,
            paddingBottom: 10,
            borderRadius: 15,
            boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
            backgroundColor: 'white',
            width: '100%',
          }}
          className='rounded-lg'
        >
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              value={searchText}
              onChange={(v) => setSearchText(v.target.value)}
              placeholder='Search…'
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
            />
          </div>
        </div>
        <IconButton onClick={() => (window.location.href = '/kai/settings')}>
          <SettingsIcon />
        </IconButton>
      </div>
      <br />
      <div
        style={{ padding: 20, borderRadius: 15, boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)', backgroundColor: 'white' }}
        className='rounded-lg'
      >
        <div style={{ display: 'flex', alignItems: 'center', columnGap: 24 }}>
          <Typography component='p'>Status:</Typography>
          <Tabs value={statusType} onChange={(_, v) => setStatusType(v)}>
            <Tab value='ALL' label='All' />
            <Tab value='PENDING_CONSENT' label='Pending Consent' />
            <Tab value='PENDING_RESPONSE' label='Pending Response' />
            <Tab value='UNRESOLVED' label='Unresolved' />
            <Tab value='CLOSED' label='Closed' />
          </Tabs>
        </div>
        <TableContainer component={Paper} elevation={0}>
          <Table key={`action_table_${showMoreView}`}>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Action</TableCell>
                <TableCell>Part(s)</TableCell>
                <TableCell>Status</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filterActionsOnSearch(actions)
                .filter((a: any) => statusType == 'ALL' || statusType == a.status)
                ?.map((d, i) => (
                  <Row key={`action_row_${i}`} action={d} refetch={refetch} />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        {isFetching && 'Loading...'}
      </div>
    </>
  )
}

interface AgentActivityTableRowProps {
  action: {
    id: string
    type: string
    editable: boolean
    partNumbers: string[]
    status: string
    title: string
    subtitle: string
    bodyType: 'text' | 'html'
    body: string
  }
  refetch: any
}

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
})

function Row({ action, refetch }: AgentActivityTableRowProps) {
  const i = action.id
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [bodyOpen, setBodyOpen] = useState(false)
  const [actionBody, setActionBody] = useState(action.body)
  const classes = useRowStyles()

  const { mutateAsync: mutateAction } = usePatchAgentAction()
  const { mutateAsync: deleteActionAPI } = useDeleteAgentAction()

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = async () => {
    setAnchorEl(null)
  }

  const handleActionStatusChange = async ({ id, status }) => {
    setBodyOpen(false)
    setAnchorEl(null)
    await mutateAction({ id, status })
    await refetch()
  }

  const handleActionBodyContentUpdate = async (content: string) => {
    await patchAgentAction({
      id: action.id,
      type: action.type,
      body: content,
    })
  }

  function ActionCellHeading() {
    return (
      <>
        {action.title}
        <br />
        <span style={{ color: 'grey' }}>{action.subtitle}</span>
      </>
    )
  }

  function ActionCellBody() {
    if (action.editable) {
      return <TextEditor key={`editor-${action.id}`} initialHtml={actionBody} onChangeCb={handleActionBodyContentUpdate} />
    }
    return (
      <p>
        {action.bodyType == 'html' && <div dangerouslySetInnerHTML={{ __html: action.body }}></div>}
        {action.bodyType == 'text' && <div>{action.body}</div>}
        <br />
      </p>
    )
  }

  function viewMoreButtonClicked() {
    setBodyOpen(!bodyOpen)
  }

  async function deleteAction() {
    setAnchorEl(null)
    setBodyOpen(false)
    await deleteActionAPI({ actionId: action.id })
    await refetch()
  }

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton size='small' onClick={viewMoreButtonClicked}>
            {bodyOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          <ActionCellHeading />
        </TableCell>
        <TableCell>
          {action['partNumbers'].slice(0, 2).join(', ')}
          {action['partNumbers'].length > 2 ? `, ${action['partNumbers'].length - 2}+` : ''}
        </TableCell>
        <TableCell>
          <Chip size='small' style={chipStyleForStatus(action.status as any)} variant='outlined' label={formatStatus(action.status)} />
        </TableCell>
        <TableCell width={65}>
          <IconButton disabled={action.status !== 'PENDING_CONSENT'} size='small' onClick={handleMenuClick} color='secondary'>
            <MoreVertIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} keepMounted open={open} onClose={handleMenuClose} elevation={1}>
            <MenuItem
              key={`menu-item-action-${i}-approve`}
              value='Approved'
              onClick={() => handleActionStatusChange({ id: action.id, status: 'APPROVED' })}
            >
              Approve
            </MenuItem>
            <MenuItem
              key={`menu-item-action-${i}-decline`}
              value='Declined'
              onClick={() => handleActionStatusChange({ id: action.id, status: 'DECLINED' })}
            >
              Decline
            </MenuItem>
            <MenuItem key={`menu-item-action-${i}-delete`} value='Deleted' onClick={deleteAction}>
              Delete
            </MenuItem>
          </Menu>
        </TableCell>
      </TableRow>
      <TableRow key={`action_table_row_${action.id}`}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={bodyOpen} timeout='auto' unmountOnExit>
            <Box margin='auto' maxWidth={800} marginTop={2}>
              <ActionCellBody />
              <br />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

export const formatStatus = (input) => {
  return input
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export function chipStyleForStatus(status: 'PENDING_CONSENT' | 'PENDING_RESPONSE' | 'CLOSED' | 'UNRESOLVED') {
  if (status === 'PENDING_CONSENT') {
    return { color: '#d08700', borderColor: '#d08700', backgroundColor: '#FEFFE5' } // yello
  } else if (status === 'PENDING_RESPONSE') {
    return { color: '#0084d1', borderColor: '#0084d1', backgroundColor: '#eff8ff' } // blue
  } else if (status === 'CLOSED') {
    return { color: '#009966', borderColor: '#009966', backgroundColor: '#F0FFF8' } // green
  } else if (status === 'UNRESOLVED') {
    return { color: 'red', borderColor: 'red', backgroundColor: '#FFF0F0' }
  }
  return {}
}

export default KaiPage
